import { z } from "zod";

/** E13.1 Selbstregistrierung eines Ladens (öffentlich, mit Turnstile). */
export const Registrierung = z.object({
  ladenName: z.string().trim().min(2, "Bitte den Namen des Ladens eingeben.").max(80),
  inhaberName: z.string().trim().min(2, "Bitte deinen Namen eingeben.").max(80),
  email: z.string().trim().toLowerCase().email("Bitte eine gültige E-Mail-Adresse eingeben."),
  demo: z.boolean().default(false),
  datenschutz: z.literal(true, { message: "Bitte die Datenschutzerklärung bestätigen." }),
  turnstile: z.string().optional(),
});
export type Registrierung = z.infer<typeof Registrierung>;

export const ABO_STATUS = ["test", "aktiv", "verzug", "gekuendigt", "frei"] as const;
export type AboStatus = (typeof ABO_STATUS)[number];

export function aboStatusText(s: AboStatus): string {
  return { test: "Testphase", aktiv: "Abo aktiv", verzug: "Zahlung offen", gekuendigt: "Gekündigt", frei: "Kostenlos" }[s];
}
